import { render, staticRenderFns } from "./vue-seamless-scroll.vue?vue&type=template&id=05f5415a"
import script from "./vue-seamless-scroll.vue?vue&type=script&lang=js"
export * from "./vue-seamless-scroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports